import type { CSSProperties } from 'react';

import type { BrandConfig } from '../template.config';

interface BrandMarkProps {
  brand: BrandConfig;
  className: string;
  fallbackClassName: string;
  style?: CSSProperties;
}

export default function BrandMark({ brand, className, fallbackClassName, style }: BrandMarkProps) {
  if (brand.logoSrc) {
    return (
      <span className={className}>
        <img
          src={brand.logoSrc}
          alt={brand.logoAlt ?? `${brand.name} logo`}
          className="h-full w-full object-contain"
        />
      </span>
    );
  }

  return (
    <span className={`${className} ${fallbackClassName}`} style={style}>
      {brand.shortName}
    </span>
  );
}
